(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jfr-engraving-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jfr-engraving-fields')) {
    customElements.define('jfr-engraving-fields',class extends HTMLElement {
      connectedCallback() {
        if(this.ready)return;
        this.ready=true;
        this.form=document.getElementById(this.dataset.formId);
        if(!this.form)return;
        this.config=JSON.parse(this.querySelector('[data-engraving-config]').textContent);
        this.area=this.querySelector('[data-engraving-fields]');
        this.saved=new Map();
        this.change=(event)=>{
          if(event.target.name==='id')this.renderFields();
        };
        this.input=()=>this.validateFields(false);
        this.submit=(event)=>{
          if(!this.validateFields(true)){event.preventDefault();event.stopImmediatePropagation();}
        };
        this.click=(event)=>{
          if(event.target.closest('button[type="submit"], input[type="submit"]')&&!this.validateFields(true)){
            event.preventDefault();event.stopImmediatePropagation();
          }
        };
        this.form.addEventListener('change',this.change);
        this.form.addEventListener('submit',this.submit,true);
        this.form.addEventListener('click',this.click,true);
        this.addEventListener('input',this.input);
        this.renderFields();
      }
      disconnectedCallback() {
        this.form?.removeEventListener('change',this.change);
        this.form?.removeEventListener('submit',this.submit,true);
        this.form?.removeEventListener('click',this.click,true);
        this.removeEventListener('input',this.input);
        this.ready=false;
      }
      renderFields() {
        this.area.querySelectorAll('input').forEach(input=>this.saved.set(input.name,input.value));
        const id=this.form.querySelector('[name="id"]').value;
        const definitions=this.config[id]||[];
        this.area.replaceChildren();
        this.hidden=definitions.length===0;
        definitions.forEach((field,index)=>{
          const wrap=document.createElement('div');
          wrap.className='jfr-engraving-field';
          const label=document.createElement('label');
          const input=document.createElement('input');
          input.id=this.dataset.formId+'-engraving-'+index;
          input.type='text';
          input.name='properties['+field.name+']';
          input.autocomplete='off';
          input.placeholder=field.placeholder||'';
          input.maxLength=Number(field.maxlength)||20;
          if(Number(field.minlength)>0)input.minLength=Number(field.minlength);
          input.required=Number(field.required)===1;
          input.dataset.pattern=field.pattern||'';
          input.dataset.patternMessage=field.pattern_message||'';
          input.value=this.saved.get(input.name)||'';
          let text=field.label||field.name;
          const language=document.documentElement.lang.split('-')[0];
          (field.locales||[]).forEach(locale=>{
            if(locale[0]===language){text=locale[1].label||text;input.placeholder=locale[1].placeholder||input.placeholder;}
          });
          label.htmlFor=input.id;
          label.textContent=text.replace('--so--maxlength--',String(input.maxLength));
          wrap.append(label,input);
          this.area.append(wrap);
        });
        this.validateFields(false);
      }
      validateFields(report) {
        const inputs=Array.from(this.area.querySelectorAll('input'));
        if(!inputs.length)return true;
        inputs.forEach(input=>{
          input.setCustomValidity('');
          if(input.value&&input.minLength>0&&input.value.length<input.minLength)input.setCustomValidity(input.minLength+' characters minimum.');
          const characterClass=input.dataset.pattern.match(/^(\[(?:\\.|[^\]])+\])/);
          if(characterClass&&input.value){
            try{
              const allowed=new RegExp('^(?:'+characterClass[1]+')$','u');
              if(Array.from(input.value).some(char=>!allowed.test(char)))input.setCustomValidity(this.dataset.patternMessage+' '+input.dataset.patternMessage);
            }catch{}
          }
        });
        if(!inputs.some(input=>input.value.trim()))inputs[0].setCustomValidity(this.dataset.emptyMessage);
        const invalid=inputs.find(input=>!input.checkValidity());
        if(invalid&&report){invalid.focus();invalid.reportValidity();}
        return !invalid;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
